import React, { useEffect } from "react";
import { Card, Button, Typography, Empty } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { useInvoices } from "../../Hooks/Account/useInvoices";
import { useDispatch, useSelector } from "react-redux";

const { Title, Text } = Typography;

const Index = () => {
  // Get the current month name using Day.js
  const currentMonth = dayjs().format("MMMM");

  const dispatch = useDispatch();

  const { get_user_report } = useInvoices();

  const userData = useSelector((state) => state.user.data);
  const [userReport, setuserReport] = React.useState([]);

  useEffect(() => {
    report_user();
  }, []);

  console.log(userData);

  const report_user = async () => {
    try {
      const data = await get_user_report(dispatch);
      setuserReport(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "50px",
      }}
    >
      {userReport.includes(userData.id) ? (
        <Card
          style={{
            width: "100%",
            maxWidth: "600px",
            textAlign: "center",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <WarningOutlined
            style={{ fontSize: "48px", color: "#faad14", marginBottom: "16px" }}
          />
          <Title level={3} style={{ marginBottom: "8px" }}>
            Invoice Not Created for {currentMonth} Month
          </Title>
          <Text type="secondary" style={{ fontSize: "16px" }}>
            It looks like you haven't created your invoice for {currentMonth}{" "}
            month yet. Let's get started and create one now!
          </Text>
          <div style={{ marginTop: "24px" }}>
            <Link to="/invoices">
              <Button
                type="primary"
                size="large"
                style={{
                  width: "200px",
                }}
              >
                Create Invoice
              </Button>
            </Link>
          </div>
        </Card>
      ) : (
        <Empty />
      )}
    </div>
  );
};

export default Index;
